import {Component, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {SubSink} from '@Common/core/utils/subsink';
import {ElementsCheckTreeModel} from '@Common/widgets/general/tree-lazy/elements-check.model';
import {Entite} from '../../core/services/entite/entite.model';
import {TreeLazyComponent} from '@Common/widgets/general/tree-lazy/tree-lazy.component';
import {StructureTreeModel} from './structure-tree.model';
import {SnackBarToastyService, typeToast} from '@Common/widgets/general/snack-bar';
import {EntiteTreeNodeService} from '@Services/gestion-universite/entite-tree-node/entite-tree-node.service';
import {DataBaseTreeModel} from '@Common/widgets/general/tree-lazy/data-base-tree.model';
import {EntiteTreeNode} from '@Services/gestion-universite/entite-tree-node/entite-tree-node.model';
import {EntiteService} from '../../core/services/entite/entite.service';

@Component({
  selector: 'app-common-entites',
  templateUrl: './entites.component.html',
  styleUrls: ['./entites.component.scss']
})
export class EntitesComponent implements OnInit, OnDestroy {

  @ViewChild('treestructures') treestructures: TreeLazyComponent<StructureTreeModel>;

  subSink = new SubSink();
  entities: Entite[];
  entitesIdsChecked: ElementsCheckTreeModel[] = [];
  idsChecked = this.entitesIdsChecked;
  entitiesChecked = [];
  loadChecked = false;
  reload = 1;
  extraParams: Map<string, string> = new Map<string, string>();

  @Input() levelMaxExpand: number;
  @Input() entityType: number;
  @Input() application: string;
  @Input() customLabel: string;


  mapToStructureTreeModel = (_nodeParent: DataBaseTreeModel, _data: EntiteTreeNode[]): StructureTreeModel[] => {
    return _data.map(struct =>
      <StructureTreeModel>{
        id: struct.id,
        name: struct.name,
        type_entite: struct.type_entite,
        label_entite: struct.label_entite,
        code_apogee: struct.code_apogee,
        code_manque: struct.code_manque,
        hasChildren: struct.hasChildren,
        level: _nodeParent ? _nodeParent.level + 1 : 1,
        expandable: struct.hasChildren,
        isExpanded: true,
        isLoading: false
      });
  }


  constructor(private snackSvc: SnackBarToastyService,
              public entiteSvc: EntiteService,
              public entiteTreeSvc: EntiteTreeNodeService) { }

  ngOnInit(): void {

    this._loadChecked();
  }

  private _loadChecked() {
    this.loadChecked = false;
    this.extraParams.set('type', this.entityType.toString());
    this.extraParams.set('application', this.application.toString());
    this.subSink.sink = this.entiteSvc.listAllItems(this.extraParams)
      .subscribe(_data => {
        this.entities = _data.list;
        this.idsChecked = _data.list.map(_elt => <ElementsCheckTreeModel> { id: _elt.entite});
        this.loadChecked = true;
      });
  }
  saved(entiteType: number) {
    if (this.entitiesChecked[entiteType] && this.entitiesChecked[entiteType].length > 0) {
      const toCreate = this.entitiesChecked[entiteType].map(_elt => <Entite> { entite: _elt, type: entiteType, application: this.application } );
      this.subSink.sink = this.entiteSvc.createBulk(toCreate).subscribe(_data => {
        this.snackSvc.toasty('Structure', `${_data['created']} directions sélectionnées`, typeToast.success);
        this._loadChecked();
        this.reload++;
      });
    }
  }
  onSelected(entite) {

  }
  onChecked(entites: ElementsCheckTreeModel[], entiteType: number) {
    this.entitiesChecked[entiteType] = entites.map(_entite => _entite.id);
  }

  /**
   * On ne va pas au delà du "LEVEL_MAX_EXPAND"
   * @param entite
   */
  public conditionExpand(entite: StructureTreeModel) {
    return entite.level < this.levelMaxExpand;
  }

  public loadSelected(): void {
    this._loadChecked();
  }

  public getEntiteLabel(){
    return (this.customLabel??this.entiteSvc.getEntiteLabel(this.entityType));
  }

  ngOnDestroy(): void {
    this.subSink.unsubscribe();
  }
}
